// Paths belonging to the unauthenticated auth flow. Kept in sync with the
// allow-list in this directory's router beforeEach guard (index.js). Used
// anywhere a "return to this page after login" URL is captured or consumed,
// so that value is never itself an auth-flow page.
export const AUTH_PAGE_PATHS = [
  '/sign_in',
  '/sign_up',
  '/invite_register',
  '/verify_email',
  '/redirect',
  '/terms_of_service'
]

export function isAuthPagePath(path) {
  return (
    typeof path === 'string' && AUTH_PAGE_PATHS.some(p => path.startsWith(p))
  )
}
